import React, { useMemo, useState } from 'react';
import { api } from '../utils/api';
import './AddCustomerModal.css';

export default function AddCustomerModal({ onClose, onSubmit }) {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEmailChange = (value) => {
    setEmail(value);
    if (errors.email) {
      setErrors((prev) => ({ ...prev, email: null }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Invalid email address';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    setIsSubmitting(true);
    try {
      const customer = await api.createCustomer(email);
      onSubmit(customer);
      onClose();
    } catch (error) {
      setErrors({ email: error.message || 'Failed to create customer' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const canSubmit = useMemo(() => {
    return email.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && !isSubmitting;
  }, [email, isSubmitting]);

  return (
    <div className="vt-modalOverlay" onClick={onClose}>
      <div className="vt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="vt-modalHeader">
          <h2 className="vt-modalTitle">Add new customer</h2>
          <button className="vt-modalClose" type="button" onClick={onClose} aria-label="Close modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5 5L15 15M15 5L5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <form className="vt-modalForm" onSubmit={handleSubmit}>
          <div className="vt-modalSection">
            <label className="vt-field">
              <span className="vt-fieldLabel">
                Email <span className="vt-required">*</span>
              </span>
              <input
                className="vt-input"
                type="email"
                value={email}
                onChange={(e) => handleEmailChange(e.target.value)}
                placeholder="john.doe@example.com"
              />
              {errors.email && <span className="vt-fieldError">{errors.email}</span>}
            </label>
          </div>


          <div className="vt-modalActions">
            <button className="vt-btn vt-btn--secondary" type="button" onClick={onClose}>
              Cancel
            </button>
            <button className="vt-btn vt-btn--primary" type="submit" disabled={!canSubmit}>
              {isSubmitting ? 'Creating...' : 'Add customer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
